import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import { graphql } from "gatsby";
import Series from "../components/series";
import { Link } from "gatsby";

const Index = ({ data }) => {
  return (
    <Layout
      series={[
        <Series
          key="postman"
          title="¿Cómo usar Postman?"
          edges={data.serie1.edges}
        ></Series>,
        <Series
          key="node.js"
          title="Node.js, ¿archivos grandes?"
          edges={data.serie2.edges}
        ></Series>,
      ]}
    >
      <SEO title="Developers blog" />
      <h1>Bienvenidos</h1>
      <p>
        Bienvenidos al cuaderno de notas de un desarrollador, intentó anotar
        todos los problemas que encuentro el el día a día laboral para
        recordarlo en un futuro y además, ayudar a otros programadores si es
        posible. Se agregan posts al menos una vez a la semana y se aceptan
        sugerencias. Asegurate de leer los{" "}
        <Link to="/blog/">últimos posts</Link>, siempre hay algo nuevo para
        aprender. Disfruta tu visita y ten un excelente día. Recuerda:{" "}
        <em>es una maratón, no una carrera</em>.
      </p>
    </Layout>
  );
};

export default Index;

export const findSeries = graphql`
  query {
    serie1: allMarkdownRemark(
      filter: { frontmatter: { series: { eq: "postman" } } }
      limit: 3
      sort: { fields: frontmatter___seriesNumber, order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            author
            date
            image {
              extension
              publicURL
              childImageSharp {
                fluid(maxWidth: 400) {
                  base64
                  aspectRatio
                  src
                  srcSet
                  sizes
                }
              }
            }
            series
            seriesNumber
            summary
            slug
            tags
            title
            imageAlt
          }
        }
      }
    }
    serie2: allMarkdownRemark(
      filter: { frontmatter: { series: { eq: "node.js archivos grandes" } } }
      limit: 3
      sort: { fields: frontmatter___seriesNumber, order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            author
            date
            image {
              extension
              publicURL
              childImageSharp {
                fluid(maxWidth: 400) {
                  base64
                  aspectRatio
                  src
                  srcSet
                  sizes
                }
              }
            }
            series
            seriesNumber
            summary
            slug
            tags
            title
            imageAlt
          }
        }
      }
    }
  }
`;
